import createIcon from '../../createIcon';

/**
 * @component @name Pending
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk03IDEzLjVDNi4xNyAxMy41IDUuNSAxMi44MyA1LjUgMTJDNS41IDExLjE3IDYuMTcgMTAuNSA3IDEwLjVDNy44MyAxMC41IDguNSAxMS4xNyA4LjUgMTJDOC41IDEyLjgzIDcuODMgMTMuNSA3IDEzLjVaTTEyIDEzLjVDMTEuMTcgMTMuNSAxMC41IDEyLjgzIDEwLjUgMTJDMTAuNSAxMS4xNyAxMS4xNyAxMC41IDEyIDEwLjVDMTIuODMgMTAuNSAxMy41IDExLjE3IDEzLjUgMTJDMTMuNSAxMi44MyAxMi44MyAxMy41IDEyIDEzLjVaTTE3IDEzLjVDMTYuMTcgMTMuNSAxNS41IDEyLjgzIDE1LjUgMTJDMTUuNSAxMS4xNyAxNi4xNyAxMC41IDE3IDEwLjVDMTcuODMgMTAuNSAxOC41IDExLjE3IDE4LjUgMTJDMTguNSAxMi44MyAxNy44MyAxMy41IDE3IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Pending = createIcon('Pending', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7 13.5C6.17 13.5 5.5 12.83 5.5 12C5.5 11.17 6.17 10.5 7 10.5C7.83 10.5 8.5 11.17 8.5 12C8.5 12.83 7.83 13.5 7 13.5ZM12 13.5C11.17 13.5 10.5 12.83 10.5 12C10.5 11.17 11.17 10.5 12 10.5C12.83 10.5 13.5 11.17 13.5 12C13.5 12.83 12.83 13.5 12 13.5ZM17 13.5C16.17 13.5 15.5 12.83 15.5 12C15.5 11.17 16.17 10.5 17 10.5C17.83 10.5 18.5 11.17 18.5 12C18.5 12.83 17.83 13.5 17 13.5Z',
      key: '1irk8o',
    },
  ],
]);

export default Pending;
